import _ from "lodash";

/**
 * Compara e retorna as diferenças entre dois objetos, recursivamente (deep).
 * Fonte: https://gist.github.com/Yimiprod/7ee176597fef230d1451
 *
 *
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export function deepDiff(object, base) {
    function changes(object, base) {
        return _.transform(object, function (result, value, key) {
            if (!_.isEqual(value, base[key])) {
                result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
            }
        });
    }
    return changes(object, base);
}

/**
 * Compara e retorna as diferenças entre dois objetos, superficialmente
 * (apenas no primeiro nível).
 */
export function shallowDiff(object, base) {
    return _.transform(object, function (result, value, key) {
        if (!_.isEqual(value, base[key])) {
            result[key] = value;
        }
    });
}

export function clearAtributes(object, param, fieldsMantem) {
    if (object) {
        const clearObj = _.get(object, param)
        if (clearObj) {

            for (const key in clearObj) {
                if (!fieldsMantem.includes(key)) {
                    delete clearObj[key];
                }
            }
        }
    }
}

export function generateUid() {
    const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    let autoId = ''

    for (let i = 0; i < 20; i++) {
        autoId += CHARS.charAt(
            Math.floor(Math.random() * CHARS.length)
        )
    }

    return autoId
}



export function normalizarTexto(texto) {
    if (!texto) {
        return ""
    }
    return texto.trim()
        .normalize("NFD")                     // separa os acentos
        .replace(/[\u0300-\u036f]/g, "")     // remove os acentos
        .toLowerCase();                      // deixa tudo minúsculo
}

export function includeInsencitive(texto1, texto2) {
    return normalizarTexto(texto1).includes(normalizarTexto(texto2));
}
